import { render, staticRenderFns } from "./AssistantServiceTabLinks.vue?vue&type=template&id=9ef69a4a"
import script from "./AssistantServiceTabLinks.vue?vue&type=script&lang=js"
export * from "./AssistantServiceTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports